import React from "react";
import { Link } from "react-router-dom";
import andUsLogo from "../../images/logolight.png";
import luminousField from "../../images/andus-central-access-luminous-field-desktop.svg";
import "../styles/platformAccess.css";

export default function AccessShell({ eyebrow, title, description, children, footer, compact = false }) {
  return (
    <main className={`pa-access-shell${compact ? " is-compact" : ""}`}>
      <section className="pa-access-brand" aria-label="AndUs intelligent systems">
        <img className="pa-access-brand__field" src={luminousField} alt="" aria-hidden="true" />
        <Link className="pa-brand-logo" to="/" aria-label="AndUs home">
          <img src={andUsLogo} alt="AndUs" />
        </Link>
        <div className="pa-access-brand__copy">
          <p>Central system access</p>
          <h1>Experience the power of intelligent systems.</h1>
        </div>
      </section>

      <section className="pa-access-workspace">
        <header className="pa-access-mobile-brand">
          <Link className="pa-brand-logo" to="/" aria-label="AndUs home">
            <img src={andUsLogo} alt="AndUs" />
          </Link>
          <span>Central system access</span>
          <strong>Experience the power of intelligent systems.</strong>
        </header>

        <div className="pa-access-card">
          <div className="pa-access-card__accent" aria-hidden="true" />
          <header className="pa-access-heading">
            <p>{eyebrow}</p>
            <h2>{title}</h2>
            {description ? <span>{description}</span> : null}
          </header>
          {children}
          {footer ? <footer className="pa-access-card__footer">{footer}</footer> : null}
        </div>

        <footer className="pa-access-utility">
          <Link to="/contactAndUs">Access support</Link>
          <span>Privacy · © 2026 AndUs</span>
        </footer>
      </section>
    </main>
  );
}
